import instance from 'api';
import { BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import {
  MfaChallengeResult,
  MfaChallengeType,
  MfaCodeSubmission,
  MfaGrantResult,
  TotpQrCodeResult,
  parseMfaError,
} from 'pages/mfa/models';

export class MfaApi extends BaseApi {
  public static challenge = (challengeType: MfaChallengeType) =>
    BaseApi.send<MfaChallengeResult>(
      () => instance.post(endpoints.profile.mfaChallenge, { challengeType }),
      parseMfaError
    );

  public static requestTotpQrCode = () =>
    BaseApi.send<TotpQrCodeResult>(
      () => instance.post(endpoints.profile.mfaRequestTotpQrCode),
      parseMfaError
    );

  public static verify = (submission: MfaCodeSubmission) =>
    BaseApi.send<MfaGrantResult>(
      () => instance.post(endpoints.profile.mfaVerify, submission),
      parseMfaError
    );

  public static enableChallengeType = (submission: MfaCodeSubmission) =>
    BaseApi.send<MfaGrantResult>(
      () => instance.post(endpoints.profile.mfaEnableChallengeType, submission),
      parseMfaError
    );

  public static disableChallengeType = (
    submission: Omit<MfaCodeSubmission, 'trustThisDevice'>
  ) =>
    BaseApi.send<null>(
      () =>
        instance.post(endpoints.profile.mfaDisableChallengeType, submission),
      parseMfaError
    );
}
